export let ScopeNamespace = /*#__PURE__*/function (ScopeNamespace) {
  ScopeNamespace["Stores"] = "stores";
  ScopeNamespace["PricingPlans"] = "pricingPlans";
  ScopeNamespace["Events"] = "events";
  ScopeNamespace["Bookings"] = "bookings";
  ScopeNamespace["Restaurants"] = "restaurants";
  return ScopeNamespace;
}({});
export let ScopeGroup = /*#__PURE__*/function (ScopeGroup) {
  ScopeGroup["Product"] = "product";
  ScopeGroup["Collection"] = "collection";
  ScopeGroup["Ticket"] = "ticket";
  ScopeGroup["Event"] = "event";
  ScopeGroup["Service"] = "service";
  ScopeGroup["Plan"] = "plan";
  ScopeGroup["Menu"] = "menu";
  ScopeGroup["MenuSection"] = "menuSection";
  ScopeGroup["MenuItem"] = "menuItem";
  return ScopeGroup;
}({});
export let ReferralAction = /*#__PURE__*/function (ReferralAction) {
  ReferralAction["StoreOrderPlaced"] = "stores";
  ReferralAction["PricingPlanOrdered"] = "pricing-plans";
  ReferralAction["EventTicketOrdered"] = "events";
  ReferralAction["SessionBooked"] = "bookings";
  ReferralAction["RestaurantOrderPlaced"] = "restaurants";
  return ReferralAction;
}({});
//# sourceMappingURL=constants.js.map